module.exports = __webpack_public_path__ + "img/tesoura de poda 1.2de0808f.webp";